export enum ERiskPageType {
  InvestmentReturn = 1,
  MaximumDecline = 2,
  StockMarketForecast = 3,
  AgeRange = 4,
  PlannedWithdrawal = 5,
  RiskTolerance = 6,
  TimeHorizon = 7,
  InvestmentPercentage = 8,
  YourRiskProfile = 9,
}
